// extracted by mini-css-extract-plugin
export default {"main":"Coin_main__y6LQ7","title":"Coin_title__yor1w","description":"Coin_description__D0LXX"};